import {updatePlantById} from "../../services/Administrative/plantService";
import {useState} from "react";
import {updateEquipment} from "../../services/Administrative/equipmentService";

export const useUpdateEquipment = () => {

    const [updatingEquipment, setUpdatingEquipment] = useState<boolean>(false);

    const updateEquipmentByUniqueCode = async (equipmentDTO: any, id: number) => {
        try {
            setUpdatingEquipment(true);
            return await updateEquipment(equipmentDTO, id);
        } catch (error:any) {
            if(!error.response.data.message){
                error.response.data.message = "Error inesperado al actualizar equipo.";
            }
            throw error;
        }
        finally {
            setTimeout(() => { setUpdatingEquipment(false) }, 600)
        }
    };

    return { updateEquipmentByUniqueCode, updatingEquipment };
};
